import { MapPin, BedDouble, Bath, Ruler, Home, MessageCircle } from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Reveal } from "./Reveal";
import { waHref } from "@/lib/wa";

const Spec = ({ icon: Icon, label, value }) => (
  <div className="flex items-center gap-2 text-sm text-slate-600">
    <Icon className="h-4 w-4 text-brand" />
    <span>
      {label}: <span className="font-semibold text-brand-dark">{value}</span>
    </span>
  </div>
);

export default function Projects({ content }) {
  return (
    <section id="perumahan" className="bg-mist-blue bg-dots-blue py-24" data-testid="projects-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <SectionHeading
          number="02"
          eyebrow="Proyek Perumahan"
          title="Temukan Hunian Impian Anda di Pontianak"
          description="Jelajahi proyek perumahan Type 36 konsep cluster yang kami kembangkan untuk keluarga Indonesia."
        />
        <div className="grid gap-8 md:grid-cols-2">
          {content.projects.map((p, i) => (
            <Reveal key={p.id || i} delay={i * 0.1}>
              <article
                className="group overflow-hidden rounded-2xl border border-slate-100 bg-white shadow-[0_8px_30px_rgb(0,0,0,0.04)] transition-all duration-300 hover:-translate-y-1 hover:shadow-[0_16px_40px_rgb(0,86,179,0.12)]"
                data-testid={`project-card-${i}`}
              >
                <div className="relative overflow-hidden">
                  <img
                    src={p.image}
                    alt={`Foto perumahan ${p.name}`}
                    className="aspect-[16/9] w-full object-cover transition-transform duration-700 group-hover:scale-105"
                    loading="lazy"
                  />
                  {p.status && !p.status.includes("[") && (
                    <span className="absolute left-4 top-4 rounded-full bg-white/90 px-3 py-1 text-xs font-semibold text-brand backdrop-blur" data-testid={`project-status-${i}`}>
                      {p.status}
                    </span>
                  )}
                </div>
                <div className="p-6 sm:p-7">
                  <h3 className="font-display text-xl font-bold text-brand-dark" data-testid={`project-name-${i}`}>{p.name}</h3>
                  <p className="mt-1 flex items-center gap-1.5 text-sm text-slate-500" data-testid={`project-location-${i}`}>
                    <MapPin className="h-4 w-4 text-brand" /> {p.location}
                  </p>
                  <div className="mt-5 grid grid-cols-2 gap-3">
                    <Spec icon={Home} label="Tipe" value={p.type} />
                    <Spec icon={Ruler} label="Tanah" value={p.landArea} />
                    <Spec icon={BedDouble} label="Kamar Tidur" value={p.bedrooms} />
                    <Spec icon={Bath} label="Kamar Mandi" value={p.bathrooms} />
                  </div>
                  <div className="mt-6 flex items-center justify-between border-t border-slate-100 pt-5">
                    <div>
                      <p className="text-xs uppercase tracking-[0.15em] text-slate-500">Harga Mulai</p>
                      <p className="font-display text-lg font-bold text-brand" data-testid={`project-price-${i}`}>{p.price}</p>
                    </div>
                    <a
                      href={waHref(content)}
                      target={waHref(content).startsWith("http") ? "_blank" : undefined}
                      rel="noopener"
                      data-testid={`project-cta-${i}`}
                      className="inline-flex items-center gap-2 rounded-full bg-brand px-5 py-2.5 text-sm font-semibold text-white transition-colors duration-200 hover:bg-brand-deep active:scale-95"
                    >
                      <MessageCircle className="h-4 w-4" />
                      Tanya Unit
                    </a>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
